const REAL_SERVER = "https://fanbird.live/F_shopping/back/";
// const TEST_SERVER = "http://52.78.248.251/F_shopping_test/";
const TEST_SERVER = "https://fanbird.live/F_shopping_dev/back/";
const JUN_SERVER = "http://192.168.0.18:3000/";

export const SERVER_ADDRESS = REAL_SERVER;

const Communication_url = {
  // user
  nick_dup_check: `${SERVER_ADDRESS}user/nick-dup-check`,
  user_join: `${SERVER_ADDRESS}user/join`,
  user_login: `${SERVER_ADDRESS}user/login`,
  seller_login: `${SERVER_ADDRESS}user/seller-login`,
  refresh: `${SERVER_ADDRESS}user/refresh`,
  user_info: `${SERVER_ADDRESS}user/user-info`,
  logout: `${SERVER_ADDRESS}user/logout`,
  dropUser: `${SERVER_ADDRESS}user/drop-user`,

  // store
  store_name_dup_check: `${SERVER_ADDRESS}store/store-name-dup-check`,
  create_store: `${SERVER_ADDRESS}store/store-create`,
  store_info: `${SERVER_ADDRESS}store/store-info`,
  store_update: `${SERVER_ADDRESS}store/store-update`,
  stock_coin: `${SERVER_ADDRESS}store/stock-coin`,

  // coin
  coin_log_list: `${SERVER_ADDRESS}coin/coin-log-list`,
  coin_charge: `${SERVER_ADDRESS}coin/coin-charging`,
  coin_charging_cancel: `${SERVER_ADDRESS}coin/coin-charging-cancel`,

  // live
  unavailable_time: `${SERVER_ADDRESS}live/unavailable-time`,
  create_live: `${SERVER_ADDRESS}live/create-live`,
  get_live_list: `${SERVER_ADDRESS}live/get-live-list`,
  get_main_live_list: `${SERVER_ADDRESS}live/get-main-live-list`,
  get_follow_live_list: `${SERVER_ADDRESS}live/get-follow-live-list`,
  get_live_info: `${SERVER_ADDRESS}live/get-live-info`,
  get_live_notice: `${SERVER_ADDRESS}live/get-live-notice`,
  create_live_notice: `${SERVER_ADDRESS}live/create-live-notice`,
  delete_live_notice: `${SERVER_ADDRESS}live/delete-live-notice`,
  modify_live_notice: `${SERVER_ADDRESS}live/modify-live-notice`,
  last_live_list: `${SERVER_ADDRESS}live/last-live-list`,
  live_cancel: `${SERVER_ADDRESS}live/live-cancel`,
  live_search: `${SERVER_ADDRESS}live/search-live`,
  send_alimtalk: `${SERVER_ADDRESS}live/send-alimtalk`,
  live_user_ban_check: `${SERVER_ADDRESS}live/live-user-ban-check `,
  motify_live_status: `${SERVER_ADDRESS}live/modify-live-status`,
  alimtalk_follow_check: `${SERVER_ADDRESS}live/alimtalk-follow-check`,
  live_auth_check: `${SERVER_ADDRESS}live/live-auth-check`,

  // relation
  user_ban: `${SERVER_ADDRESS}relation/user-ban`,
  user_unban: `${SERVER_ADDRESS}relation/user-unban`,
  follow_user_list: `${SERVER_ADDRESS}relation/follow-user-list`,
  ban_user_list: `${SERVER_ADDRESS}relation/ban-user-list`,
  store_follow: `${SERVER_ADDRESS}relation/store-follow`,
  store_unfollow: `${SERVER_ADDRESS}relation/store-unfollow`,

  // product
  product_list: `${SERVER_ADDRESS}product/product-list`,
  product_update: `${SERVER_ADDRESS}product/product-update`,
  product_create: `${SERVER_ADDRESS}product/product-create`,
  search_product: `${SERVER_ADDRESS}product/search-product`,
  product_option_enable: `${SERVER_ADDRESS}product/product-option-enable`,
  option_tag_create: `${SERVER_ADDRESS}product/option-tag-create`,
  option_tag_list: `${SERVER_ADDRESS}product/option-tag-list`,
  option_tag_delete: `${SERVER_ADDRESS}product/option-tag-delete`,
  search_option_tag: `${SERVER_ADDRESS}product/search-option-tag`,
  product_option_save: `${SERVER_ADDRESS}product/product-option-save`,
  product_option_info: `${SERVER_ADDRESS}product/product-option-info`,
  product_option_delete: `${SERVER_ADDRESS}product/product-option-delete`,
  create_last_live_product: `${SERVER_ADDRESS}product/create-last-live-product`,
  product_excel_upload: `${SERVER_ADDRESS}product/product-excel-upload`,
  product_name_list: `${SERVER_ADDRESS}product/product-name-list`,
  is_visable_product: `${SERVER_ADDRESS}product/is-visable-product`,
  product_option_info: `${SERVER_ADDRESS}product/product-option-info`,

  // orders
  get_order_list: `${SERVER_ADDRESS}orders/order-list`,
  store_dashboard: `${SERVER_ADDRESS}orders/store-dashboard`,
  order: `${SERVER_ADDRESS}orders/order`,
  order_info: `${SERVER_ADDRESS}orders/order-info`,
  order_address_update: `${SERVER_ADDRESS}orders/order-address-update`,
  order_detail_update: `${SERVER_ADDRESS}orders/order-detail-update`,
  order_delete: `${SERVER_ADDRESS}orders/order-delete`,
  update_all_order_status: `${SERVER_ADDRESS}orders/update-all-order-status`,
  order_count: `${SERVER_ADDRESS}orders/order-count`,
  live_order_count: `${SERVER_ADDRESS}orders/live-order-count`,
  statement_info: `${SERVER_ADDRESS}orders/statement-info`,
  send_statement: `${SERVER_ADDRESS}orders/send-statement`,

  // file
  upload_license: `${SERVER_ADDRESS}file/upload-license`,
  upload_store_profile: `${SERVER_ADDRESS}file/upload-store-profile`,
  upload_live_img: `${SERVER_ADDRESS}file/upload-live-img`,

  // aws-ivs
  live_status: `${SERVER_ADDRESS}aws-ivs/live-status`,
  getStreamInfo: `${SERVER_ADDRESS}aws-ivs/getStreamInfo`,

  // chat
  createChatToken: `${SERVER_ADDRESS}aws-ivs-chat/createChatToken`,
};

const url = {
  Communication_url,
};
export default url;
